import axios from "axios";

export async function getLicencesByCompany(companyId: string, token:string): Promise<any> {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/licencas/empresa/${companyId}`, {
        headers: {
            Authorization: 'Bearer ' + token
        }
        });
  
      return response.data; // Supondo que as licenças sejam retornadas pelo backend
    } catch (error) {
      throw new Error('Falha na autenticação');
    }
}

export async function getLicencesByCompanyDashboard(companyId: string, token:string): Promise<any> {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_URL+`/licencas/empresa/${companyId}/dashboard`, {
      headers: {
          Authorization: 'Bearer ' + token
      }
      });

    return response.data; // Supondo que as licenças sejam retornadas pelo backend
  } catch (error) {
    throw new Error('Falha na autenticação');
  }
}